import { createSlice, current } from '@reduxjs/toolkit'
import { THEME_CONFIG } from 'configs/AppConfig'

// Layout preferences the user changes often — keep them across reloads.
const PERSIST_KEY = 'cf:shellPrefs';
const PERSISTED_FIELDS = ['navCollapsed', 'navLayout', 'navFavorites', 'sideNavTheme'];

function readPersisted() {
	try {
		const raw = localStorage.getItem(PERSIST_KEY);
		if (!raw) return {};
		const parsed = JSON.parse(raw);
		return parsed && typeof parsed === 'object' ? parsed : {};
	} catch {
		return {};
	}
}

function persist(draft) {
	try {
		const state = current(draft);
		const out = {};
		PERSISTED_FIELDS.forEach((k) => { out[k] = state[k]; });
		localStorage.setItem(PERSIST_KEY, JSON.stringify(out));
	} catch {
		// storage unavailable — ignore
	}
}

const stored = readPersisted();

export const initialState = {
	...THEME_CONFIG,
	navLayout: THEME_CONFIG.navLayout || 'sidebar',
	navFavorites: [],
	launcherOpen: false,
	...stored,
	navFavorites: Array.isArray(stored.navFavorites) ? stored.navFavorites : [],
	launcherOpen: false,
}

export const themeSlice = createSlice({
	name: 'theme',
	initialState,
	reducers: {
        toggleCollapsedNav: (state, action) => {
			state.navCollapsed = action.payload
			persist(state)
		},
        onNavStyleChange: (state, action) => {
			state.sideNavTheme = action.payload
			persist(state)
		},
        onLocaleChange: (state, action) => {
			state.locale = action.payload
		},
        onNavTypeChange: (state, action) => {
			state.navType = action.payload
		},
        onTopNavColorChange: (state, action) => {
			state.topNavColor = action.payload
		},
        onHeaderNavColorChange: (state, action) => {
			state.headerNavColor = action.payload
		},
        onMobileNavToggle: (state, action) => {
			state.mobileNav = action.payload
		},
        onSwitchTheme: (state, action) => {
			state.currentTheme = action.payload
		},
        onDirectionChange: (state, action) => {
			state.direction = action.payload
		},
		onBlankLayout: (state, action) => {
			state.blankLayout = action.payload
		},
		// 'sidebar' = classic left menu; 'launcher' = tablet-style app grid
		onNavLayoutChange: (state, action) => {
			state.navLayout = action.payload === 'launcher' ? 'launcher' : 'sidebar'
			if (state.navLayout === 'sidebar') state.launcherOpen = false
			persist(state)
		},
		onLauncherToggle: (state, action) => {
			state.launcherOpen = typeof action.payload === 'boolean' ? action.payload : !state.launcherOpen
		},
		toggleNavFavorite: (state, action) => {
			const key = action.payload
			if (!key) return
			const idx = state.navFavorites.indexOf(key)
			if (idx >= 0) state.navFavorites.splice(idx, 1)
			else state.navFavorites.push(key)
			persist(state)
		},
		setNavFavorites: (state, action) => {
			state.navFavorites = Array.isArray(action.payload) ? action.payload : []
			persist(state)
		},
	},
})

export const { 
    toggleCollapsedNav,
    onNavStyleChange,
    onLocaleChange,
    onNavTypeChange,
    onTopNavColorChange,
    onHeaderNavColorChange,
    onMobileNavToggle,
    onSwitchTheme,
    onDirectionChange,
	onBlankLayout,
	onNavLayoutChange,
	onLauncherToggle,
	toggleNavFavorite,
	setNavFavorites,
} = themeSlice.actions

export default themeSlice.reducer
